import { useContext } from "react";

import { BaseForm } from "common/components/templates/BaseForm";
import { DashboardTemplate } from "common/components/templates/DashboardTemplate";
import FormContainer from "common/components/templates/FormContainer";

import AuthContext from "common/store/AuthContext";
import { SimpleTopBar } from "../../common/components/organisms/SimpleTopBar";
import { ImportTasksPanel } from "./components/ImportTasksPanel";

export const ImportTasksPage = (props: { pageTitle: string }) => {
  const { selectedPark } = useContext(AuthContext);

  return (
    <DashboardTemplate>
      <FormContainer size="max">
        <SimpleTopBar parkName={selectedPark?.parkName ?? "公園不明"} pageTitle={props.pageTitle} />

        {!selectedPark ? (
          <div> 公園が選択されていません </div>
        ) : !selectedPark.isAdmin ? (
          <div>管理者以外は利用できません</div>
        ) : (
          <BaseForm className="p-3">
            <ImportTasksPanel />
          </BaseForm>
        )}
      </FormContainer>
    </DashboardTemplate>
  );
};
